import { Row, Col, Spacer } from '@amzn/stencil-react-components/layout';
import { H3, Text } from '@amzn/stencil-react-components/text';
import React from 'react';
import Img1 from '../../img/WelcomeSlides/slide1-img1.png';
import Img2 from '../../img/WelcomeSlides/slide1-img2.png';

const Slide1 = () => {
  return (
    <Col alignItems="center">
      <H3>Welcome to Nudge Engine</H3>
      <Spacer height={12} />
      <Text style={{ fontStyle: 'italic' }}>
        A small nudge can reinforce your effort to get your employees to act!
      </Text>
      <Text>
        Designed for the PXT team, Nudge Engine delivers personalized, easy-to-act on nudges to help
        your employees develop better decision making and action orientation!
      </Text>

      <Row flex="1" alignItems="center">
        <Col>
          <img async src={Img1} width={'100%'} />
        </Col>
        <Col>
          <img async src={Img2} width={'100%'} />
        </Col>
      </Row>
    </Col>
  );
};

export default Slide1;
